// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"55":"room-details","594":"about","602":"hotel-details","659":"property-rooms"}[chunkId] + "." + {"55":"6e2e718e","594":"7d45e8bb","602":"ce4095b5","659":"75329c8f"}[chunkId] + ".css";
};